<template>
  <div class="confirm-tender spacey-20">
    <div class="h4 grey-900">
      {{
        isDeclined
          ? $t('Your company declined participation in the tender')
          : `${$t('New tender from')} ${companyName}`
      }}
    </div>
    <div
      v-if="isDeclined && declinedUser"
      class="declined-user-wrapper spacex-16 flex-row vertical-centering"
    >
      <span class="danger-600 text-sm">{{ $t('Declined by') }}</span>
      <UserInfo :user="declinedUser" avatar-size="24" show-in-one-row :show-position="false" />
      <Badge color="light-grey" bordered>
        <span class="capitalize">{{ $t(declinedUser.position) }}</span>
      </Badge>
    </div>
    <p v-if="isDeclined" class="text-body grey-900">
      {{ $t(`You can change your decision. After that, you'll be able to create an offer.`) }}
    </p>
    <div v-else>
      <p class="text-body grey-900">
        {{
          $t(
            `You can study all the information about the tender, see all the local estimates and ask all the questions to the contact person in the chat on the right. You can also invite your team members to join the project on the top right.`
          )
        }}
      </p>
      <p class="text-body">
        {{
          $t(
            'Then choose one of the actions below: participate or decline. If you decline it, you may change your decision later and participate.'
          )
        }}
      </p>
    </div>
    <div class="confirm-tender__buttons vertical-centering spacex-8">
      <Button @click="confirmHandler">
        {{ isDeclined ? $t('Participate in tender') : $t('Confirm participation') }}
      </Button>
      <Button v-if="!isDeclined" color="neutral" :loading="declineLoading" @click="declineHandler">
        {{ $t('Decline tender') }}
      </Button>
    </div>
  </div>
</template>

<script>
  import Button from '@/components/ui/Button';
  import Badge from '@/components/ui/Badge';
  import UserInfo from '@/components/ui/UserInfo';
  import { mapActions } from 'vuex';
  import ChooseCurrencyWindow from '@/containers/incoming-tender/ChooseCurrencyWindow';
  import CreateOfferModal from '@/containers/incoming-tender/CreateOfferModal';

  export default {
    name: 'ConfirmDeclineWindow',
    components: { Button, Badge, UserInfo },
    props: {
      declineLoading: {
        type: Boolean,
        default: false,
      },
      confirmLoading: {
        type: Boolean,
        default: false,
      },
      isDeclined: {
        type: Boolean,
        default: false,
      },
      declinedUser: {
        type: Object,
        default: null,
      },
      companyName: {
        type: String,
        required: true,
      },
    },
    methods: {
      ...mapActions({
        confirm: 'confirmModal/openModal',
        closeModal: 'modal/closeModal',
        openModal: 'modal/openModal',
      }),
      confirmHandler() {
        this.openModal({
          component: ChooseCurrencyWindow,
          context: {
            title: this.$t('Choose currency to participate in this tender'),
            description: this.$t(
              'Set a currency of your future offers. Your customer will set a conversion rate to their currency.'
            ),
            emitter: ({ currency }) => {
              this.openModal({
                component: CreateOfferModal,
                context: {
                  currency,
                },
              });
            },
          },
        });
        // this.confirm({
        //   title: this.$t('Are you ready to participate? '),
        //   description: this.$t(
        //     `After proceeding to the next step, you will receive instructions on how to send offers.`
        //   ),
        //   actionText: this.$t('Participate in tender'),
        //   cancelText: this.$t('Return'),
        //   action: () => {
        //     this.$emit('confirm');
        //   },
        // });
      },
      declineHandler() {
        this.confirm({
          title: this.$t('Are you sure you want to reject the tender?'),
          description: this.$t(
            `We will notify the customer. You’ll be able to return to the tender in the archive section.`
          ),
          actionText: this.$t('Decline tender'),
          cancelText: this.$t('Return'),
          style: 'danger',
          action: () => {
            this.$emit('decline');
          },
        });
      },
    },
  };
</script>

<style scoped lang="scss">
  @import 'src/styles/colors';

  .confirm-tender {
    background-color: $grey50;
    padding: 20px;
    border-radius: 12px;
    .declined-user-wrapper {
      border: 1px solid $grey100;
      border-radius: 4px;
      padding: 12px;
    }
  }
</style>
